import endpoint from '@app/endpoint';
import { startLoading, endLoading } from '@app/actions/spinnerActions';
import { SET_IS_AUTHORIZED } from './_types';

export const setAuthorizationStatus = isAuthorized => ({
  type: SET_IS_AUTHORIZED,
  payload: isAuthorized,
});

export const getAuthorizationStatus = () => dispatch =>
  new Promise(resolve => {
    dispatch(startLoading());
    endpoint.checkAccountStatus(
      response => {
        const { textContent: statusCode } = response.querySelector('httpStatusCode');
        const isAuthorized = Number(statusCode) === 200;
        dispatch(setAuthorizationStatus(isAuthorized));
        dispatch(endLoading());
        resolve(isAuthorized);
      },
      null,
      this,
    );
  });
